<template>
  <b-modal ref="modal-detalhe-alerta" size="lg" hide-footer @hide="hide()">
    <template v-slot:modal-title>
      <div class="d-flex align-items-center">
        <span v-if="alerta.label == 'warning'" class="lnr lnr-warning display-4 text-warning"></span>
        <span v-else-if="alerta.label == 'success'" class="lnr lnr-checkmark-circle display-4 text-success"></span>
        <span v-else-if="alerta.label == 'danger'" class="lnr lnr-cross-circle display-4 text-danger"></span>
        <span v-else-if="alerta.label == 'info'" class="lnr lnr-question-circle display-4 text-info"></span>
        <span class="ml-2">
          {{ $t('Notificação') }}
        </span>
      </div>
    </template>

    <b-form-row>
      <div class="col-3">
        <label class="form-label">ID</label>
        <span class="d-block text-muted bg-light rounded p-2">{{ alerta.id }}</span>
      </div>
      <div class="col-9">
        <label class="form-label">{{ $t('Título') }}</label>
        <span class="d-block text-muted bg-light rounded p-2">{{ alerta.titulo }}</span>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-12 mt-3">
        <label class="form-label">{{ $t('Descrição') }}</label>
        <b-form-textarea
          class="border-0 text-muted"
          v-model="alerta.descricao"
          rows="1"
          max-rows="8"
          no-resize
          disabled
          style="overflow: hidden"
        />
      </div>
    </b-form-row>

    <b-form-row class="mt-3" v-if="alerta.id_alerta">
      <div class="col-6 col-lg-3">
        <label class="form-label">{{ $t('Limite') }}</label>
        <span class="d-block text-muted bg-light rounded p-2 text-right">{{ alerta.limite_premio }}</span>
      </div>

      <div class="col-6 col-lg-3">
        <label class="form-label">{{ $t('Chave Fornecedor') }}</label>
        <span class="d-block text-muted bg-light rounded p-2">{{ alerta.id_evento_fornecedor }}</span>
      </div>

      <div class="col-6 col-lg-3 mt-3 mt-lg-0">
        <label class="form-label">{{ $t('Percentual') }}</label>
        <span class="d-block text-muted bg-light rounded p-2 text-right">{{ alerta.percentual }}</span>
      </div>

      <div class="col-6 col-lg-3 mt-3 mt-lg-0">
        <label class="form-label">{{ $t('Momento Notificação') }}</label>
        <span class="d-block text-muted bg-light rounded p-2">{{
          $util.formatDateTime(alerta.momento_cadastro)
        }}</span>
      </div>
    </b-form-row>

    <b-form-row class="mt-2">
      <div class="col-12"></div>
    </b-form-row>

    <b-form-row class="justify-content-end mt-4">
      <b-button @click="hide()">{{ $t('Fechar') }}</b-button>
    </b-form-row>
  </b-modal>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      alerta: {
        id: null,
        titulo: null,
        descricao: null,
        id_alerta: null,
        limite_premio: null,
        id_evento_fornecedor: null,
        percentual: null,
        momento_cadastro: null,
        label: null
      }
    };
  },
  computed: {},

  methods: {
    show(alerta) {
      if (alerta) {
        this.alerta = alerta;
      }
      this.$refs['modal-detalhe-alerta'].show();
    },
    hide() {
      this.resetModal();
      this.$refs['modal-detalhe-alerta'].hide();
    },
    resetModal() {
      this.alerta = {
        id: null,
        titulo: null,
        descricao: null,
        id_alerta: null,
        limite_premio: null,
        id_evento_fornecedor: null,
        percentual: null,
        momento_cadastro: null,
        label: null
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
